export const persistedName = "project_qa_site_surveillances_new";
